import Backbone from "backbone";
import * as Mustache from "mustache";
import * as _ from "underscore";

// options:
//
// - field
// - possibles
const SelectView = Backbone.View.extend({
  optionTemplate:
    '<option data-value="{{value}}" {{#selected}}selected{{/selected}}>{{text}}</option>',
  events: {
    change: "changeValue",
  },
  tagName: "select",
  className: "customSelect",
  initialize: function (options) {
    this.options = options || {};
    const that = this;

    const optionsHtml = _.map(this.options.options, (option) => {
      if (option.value === this.model.get(this.options.field)) {
        option.selected = true;
      }
      return Mustache.render(this.optionTemplate, option);
    });
    this.$el.html(optionsHtml);

    this.listenTo(this.model, "change:" + that.options.field, () => {
      if (!that._suppressUpdates) {
        const $option = that.$el.find(
          'option[data-value="' + that.model.get(that.options.field) + '"]'
        );

        if ($option.length > 0) {
          $option.prop("selected", true);
          that.$el.show();
        } else {
          that.$el.hide();
        }
      }
    });
  },
  suppressUpdates: function (callback) {
    this._suppressUpdates = true;
    callback();
    this._suppressUpdates = false;
  },
  changeValue: function () {
    const that = this;
    const value = this.$el.find("option:selected").attr("data-value");

    const changeHash = {};
    changeHash[this.options.field] = value;

    this.suppressUpdates(() => {
      that.model.set(changeHash);

      // Save model if url is set
      if (typeof that.model.url === "string") {
        that.model.save();
      }
    });
  },
});

export default SelectView;
